import React from 'react'
import { Drawer, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import CircleLoader from 'components/Loading/CircleLoader'
import EditForm from './EditForm'

function SingleItemForm({
  onPanelClose,
  isFormOpened,
  isSavingForm,
  siteType,
  snapshot,
  siteId,
  specieId,
  year,
  setScrollHeight,
  scrollToCurrentProduct,
  activeSiteRow: { client, site: siteSIEP, monthYear },
}) {
  return (
    <Drawer
      className="info-panel projected-sites-manager-form"
      variant="persistent"
      anchor="right"
      open={isFormOpened}
      classes={{
        paper: 'info-panel-paper',
      }}>
      <CircleLoader loading={isSavingForm} />
      <div className="info-panel-header">
        <Typography className="info-title" variant="subtitle1">
          {!!client && <span>{client}</span>}
          {!!siteSIEP && <span>{siteSIEP}</span>}
          {!!monthYear && <span>{monthYear}</span>}
        </Typography>
        <div className="action-group">
          <IconButton size="small" onClick={onPanelClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <EditForm
        onPanelClose={onPanelClose}
        siteType={siteType}
        snapshot={snapshot}
        siteId={siteId}
        specieId={specieId}
        year={year}
        setScrollHeight={setScrollHeight}
        scrollToCurrentProduct={scrollToCurrentProduct}
      />
    </Drawer>
  )
}

export default connect(state => ({
  activeSiteRow: state.getIn(['projectedSitesManager', 'activeSiteRow']),
  isSavingForm: state.getIn(['projectedSitesManager', 'isSavingForm']),
}))(SingleItemForm)
